(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[504],{

/***/ "bgvD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EarlySun", function() { return EarlySun; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var EarlySun = function EarlySun(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 406"
  }, props, {
    ref: xRef
  }), __jsx("g", {
    fillRule: "evenodd"
  }, __jsx("path", {
    d: "M266.877.494a9.2 9.2 0 0 0-9.2 9.2v64.401h18.4v-64.4a9.2 9.2 0 0 0-9.2-9.201zm133.447 35.812a9.2 9.2 0 0 0-12.568 3.368l-32.2 55.772 15.935 9.2 32.2-55.772a9.2 9.2 0 0 0-3.367-12.568zm97.706 97.614a9.2 9.2 0 0 0-12.567-3.367l-55.773 32.2 9.2 15.935 55.773-32.2a9.2 9.2 0 0 0 3.367-12.568zM.18 267.201a9.2 9.2 0 0 0 9.2 9.2h64.4v-18.4H9.38a9.2 9.2 0 0 0-9.2 9.2zm35.714 133.463a9.2 9.2 0 0 0 12.568 3.367l55.773-32.2-9.2-15.935-55.773 32.2a9.2 9.2 0 0 0-3.368 12.568zm0-266.744a9.2 9.2 0 0 0 3.368 12.568l55.773 32.2 9.2-15.935-55.773-32.2a9.2 9.2 0 0 0-12.568 3.367zm88.509-104.987a9.2 9.2 0 0 0-3.368 12.568l37.601 65.126 15.935-9.2-37.6-65.126a9.2 9.2 0 0 0-12.568-3.368z"
  }), __jsx("path", {
    d: "M160.445 354.749c-20.033-24.399-31.26-55.045-31.26-87.48 0-76.216 61.785-138.001 138.001-138.001 60.17 0 112.537 38.83 130.989 94.43-95.04 4.487-183.22 53.161-237.73 131.05zm258.772-124.342c-16.83-69.642-79.41-119.54-152.03-119.54-86.38 0-156.403 70.024-156.403 156.403 0 41.182 15.999 79.867 44.09 108.848l8.074 8.329 6.272-9.758c52.618-81.863 143.73-132.164 241.126-132.922l11.595-.09-2.724-11.27z",
    fillRule: "nonzero"
  })));
};

/***/ })

}]);